'use strict';

/**
 * Amplience storefront JS bundle entry.
 *
 * Runs synchronously when the script loads (before app.js) so
 * mobile-navigation-modals can snapshot modal attributes before Born
 * modules strip them on DOMContentLoaded.
 */
import './carousels/slick.min.js';

import { initGlobalPromoBanner } from './global-promo-banner';
import { initSlickCarousels } from './carousels/slick-carousel-init';
import { initAutoRotateCarousel } from './carousels/auto-rotate-carousel';
import { initProductCarouselStrips } from './carousels/product-carousel-strip';
import { initDesktopNavigation } from './navigation/desktop-navigation';
import { initMobileNavigation } from './navigation/mobile-navigation';
import { initMobileNavigationModalsIntegration } from './navigation/mobile-navigation-modals';
import { initImageProgressiveLoading } from './image';
import { initContentCardDate } from './content-card-date';
import { initUserUtilityLinks } from './user-utility-links';
import { initMediaOverlayVideos } from './media-overlay-video';
import { initMediaOverlayCarousels } from './carousels/media-overlay-carousel';
import { initPlpInGridContent } from './plp-in-grid-content';
import { initFirstSpiritContent } from './firstspirit-content';

/**
 * Runs all Amplience component initializers in dependency order.
 *
 * @private
 */
function _initAmplience() {
    initGlobalPromoBanner();
    initSlickCarousels();
    initAutoRotateCarousel();
    initProductCarouselStrips();
    initDesktopNavigation();
    initMobileNavigation();
    initMobileNavigationModalsIntegration();
    initImageProgressiveLoading();
    initContentCardDate();
    initUserUtilityLinks();
    initMediaOverlayVideos();
    initMediaOverlayCarousels();
    initPlpInGridContent();
    initFirstSpiritContent();
}

_initAmplience();
